import { useState } from 'react';
import type { DoiTuong, DonViTinh, GiaMua, NgoaiTe, VatTu } from '@/types/schemas';

const useSearchFieldStates = (initialData?: GiaMua | null) => {
  const [vatTu, setVatTu] = useState<VatTu | null>(initialData?.ma_vt_data || null);
  const [donViTinh, setDonViTinh] = useState<DonViTinh | null>(initialData?.dvt_data || null);
  const [nhaCungCap, setNhaCungCap] = useState<DoiTuong | null>(initialData?.ma_kh_data || null);
  const [ngoaiTe, setNgoaiTe] = useState<NgoaiTe | null>(initialData?.ma_nt_data || null);

  return {
    vatTu,
    setVatTu,
    donViTinh,
    setDonViTinh,
    nhaCungCap,
    setNhaCungCap,
    ngoaiTe,
    setNgoaiTe
  };
};

export default useSearchFieldStates;
